export enum CompanyPolicyFilterOptions {
    None = 1,
    Deleted = 2
}
